import { useCurrentLocation } from '../hooks/useCurrentLocation';
import { isOneIdHostname, useIdentity } from '../hooks/useIdentity';
import { isAIPanelHidden } from '../utils';
import { useVariant, Variant } from '../GlobalNav/hooks/useVariant';

export const useAiPanelHidden = (): boolean => {
  const { pathname } = useCurrentLocation();
  const { hasPermission } = useIdentity();
  const variant = useVariant();

  if (isAIPanelHidden(pathname)) {
    return true;
  }

  // OneID defaults to NavigationContext variant "billing", but AI access there
  // is controlled by /api/configs + page allowlist in Concierge — not genesis
  // AIFeaturesAccess. Do not hide the launcher for missing Billing permissions.
  if (isOneIdHostname()) {
    return false;
  }

  if (
    variant === Variant.BILLING &&
    !hasPermission('permission.AIFeaturesAccess')
  ) {
    return true;
  }

  return false;
};
